import React from "react";
import { Link } from "react-router-dom";
import BookCallButton from "components/booking/BookCallButton";
import './Hero.css';

const CAPABILITIES = [
  { icon: "fa-robot", label: "AI Agents & LLM Apps" },
  { icon: "fa-laptop-code", label: "Web Platforms" },
  { icon: "fa-mobile-screen-button", label: "iOS & Android" },
  { icon: "fa-cloud", label: "Cloud & APIs" },
];

function Hero() {
  return (
    <>
      <section className="hero-section" id="home">
        <div className="hero-glow" aria-hidden="true" />
        <div className="container pt-7 pt-md-11">
          <div className="row gx-0 gy-10 align-items-center">
            <div className="col-lg-12 text-center">
              <span className="hero-eyebrow mb-5">
                <i className="fa-solid fa-wand-magic-sparkles" />
                AI-first product engineering studio
              </span>
              <h1 className="display-1 text-white mb-5 hero-title">
                We build intelligent software that{" "}
                <span className="hero-highlight">scales with you</span>
              </h1>
              <div className="col-lg-10 col-xl-8 mx-auto">
                <p className="lead text-white mb-7 hero-lead">
                  Dobedo Soft partners with startups and enterprises worldwide to
                  design, build and run AI-powered products — from LLM agents and
                  knowledge assistants to web, mobile and cloud platforms.
                </p>
              </div>
              <div className="d-flex justify-content-center flex-wrap gap-3 mb-8">
                <BookCallButton className="btn btn-lg btn-primary rounded hero-btn">
                  Book a Discovery Call
                </BookCallButton>
                <Link
                  to="/contact-us"
                  className="btn btn-lg btn-outline-white rounded hero-btn"
                >
                  Start Your Project
                  <i className="fa-solid fa-arrow-right ms-2" />
                </Link>
              </div>

              <ul className="hero-capabilities list-unstyled mb-9">
                {CAPABILITIES.map((c) => (
                  <li key={c.label}>
                    <i className={`fa-solid ${c.icon}`} />
                    {c.label}
                  </li>
                ))}
              </ul>

              <div className="hero-stats">
                <p className="text-white text-uppercase fs-12 letter-spacing-2 mb-4 hero-stats-label">
                  <i className="fas fa-shield-alt text-primary me-2"></i>
                  Trusted by startups &amp; businesses worldwide
                </p>
                <div className="d-flex justify-content-center flex-wrap hero-stats-row">
                  <div className="counter-item">
                    <span className="counter-value text-primary fw-bold display-4">
                      50+
                    </span>
                    <p className="text-white fs-14 mt-2 mb-0">Projects Delivered</p>
                  </div>
                  <div className="counter-item">
                    <span className="counter-value text-primary fw-bold display-4">
                      20+
                    </span>
                    <p className="text-white fs-14 mt-2 mb-0">Happy Clients</p>
                  </div>
                  <div className="counter-item">
                    <span className="counter-value text-primary fw-bold display-4">
                      5+
                    </span>
                    <p className="text-white fs-14 mt-2 mb-0">Years Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
